/**
 * Utility functions for showing toast notifications
 */

/**
 * Show a toast notification
 * @param {Object} toast - Toast instance from useToast
 * @param {string} severity - Severity level ('success', 'info', 'warn', 'danger')
 * @param {string} message - Message to display
 * @param {string} [summary] - Optional summary text
 * @param {number} [life=3000] - Duration in milliseconds
 */
export const showToast = (
    toast,
    severity,
    message,
    summary = null,
    life = 3000
) => {
    toast.add({
        severity,
        detail: message,
        summary,
        life,
    })
}

/**
 * Show success toast notification
 * @param {Object} toast - Toast instance from useToast
 * @param {string} message - Message to display
 * @param {string} [summary] - Optional summary text
 */
export const showSuccess = (toast, message, summary = null) => {
    showToast(toast, 'success', message, summary)
}

/**
 * Show error toast notification
 * @param {Object} toast - Toast instance from useToast
 * @param {string} message - Message to display
 * @param {string} [summary] - Optional summary text
 */
export const showError = (toast, message, summary = null) => {
    showToast(toast, 'danger', message, summary)
}

/**
 * Show warning toast notification
 * @param {Object} toast - Toast instance from useToast
 * @param {string} message - Message to display
 * @param {string} [summary] - Optional summary text
 */
export const showWarning = (toast, message, summary) => {
    showToast(toast, 'warn', message, summary)
}

/**
 * Show info toast notification
 * @param {Object} toast - Toast instance from useToast
 * @param {string} message - Message to display
 * @param {string} [summary] - Optional summary text
 */
export const showInfo = (toast, message, summary = null) => {
    showToast(toast, 'info', message, summary)
}

export default {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
}
